import media_utility from './media_utility';
import AtTa from "../components/at_custom/AtTextarea";

export default {
  name: "attachment_dialog",
  components: {
    AtTa
  },
  props: ['showDialog', 'attachment_src', 'participants', 'message', 'fromBoards'],
  data: () => ({
    img: '',
    imageLoader: true,
    err_msg: '',
    get_attachment: [],
    attachment_preview_object: {},
    attachment_file_object: {},
    pageCount: 0,
    attachment_content_style: {
      width: '280px'
    },
    imageObject: {},
    loading: false,
    alert: false,
    alert_color: '',
    skip_enter_for_select_mention_user: false,
    text_msg: ''
  }),
  computed: {
    dialog: {
      get: function () {
        return this.showDialog;
      },
      set: function (value) {
        this.$emit("dialogClose", value);
      }
    }
  },
  mounted() {
  },
  methods: {
    /**
    * addFileUpload
    */
    async addFileUpload(e) {
      let files = e.target.files;
      await this.addFiles(files);
    },
    /**
    * getImageObject
    */
    async getImageObject(src) {
      var img = new Image();
      img.onload = async () => {
        this.imageObject = img;

        if (this.imageObject.width >= 500) {
          this.attachment_content_style.width = (this.imageObject.width) / 5 + 'px';
        }
        else {
          this.attachment_content_style.width = this.imageObject.width + 'px';
        }

        if (this.imageObject.height >= 300) {
          this.attachment_content_style.height = '275px';
        }
        else {
          this.attachment_content_style.height = this.imageObject.height + 'px';
        }
      }
      img.src = src;
    },
    /**
    * selectDocument
    */
    selectDocument(document) {
      this.attachment_preview_object = document;
      this.attachment_file_object = document.file;
      this.getImageObject(document.url);
    },
    /**
    * attachment_delete
    */
    attachment_delete(index, attachment) {
      var total_attachment = this.get_attachment.length;
      let next_attachment = {};
      if (attachment.url == this.attachment_preview_object.url) {
        if (total_attachment > 1) {
          if ((total_attachment - 1) == index) {
            next_attachment = this.get_attachment[index - 1];
          }
          else {
            next_attachment = this.get_attachment[index + 1];
          }
        }
        else {
          next_attachment = {};
          this.dialog_close();
        }
      }

      this.$delete(this.get_attachment, index);
      if (Object.keys(next_attachment).length > 0) {
        this.attachment_preview_object = next_attachment;
        this.attachment_file_object = next_attachment.file;
        this.getImageObject(next_attachment.url);
      }
    },
    /**
    * dialog_close
    */
    dialog_close() {
      this.$emit('attachment_file_src_obj', null);
      this.attachment_preview_object = {};
      this.attachment_file_object = {};
      this.get_attachment = [];
      this.alert = false;
      this.err_msg = '';
      this.dialog = false;
    },
    /**
    * send_attachment
    */
    send_attachment() {
      this.$emit('collect_attachment_files', this.get_attachment);
      this.dialog_close();
    },
    /**
    * addFiles
    */
    async addFiles(attachments) {
      if (attachments && attachments.length > 0) {
        attachments.forEach(async attachment => {
          let fileType = await media_utility.getFileType(attachment.type);

          let attachmentRespObj = await media_utility.file_size_validation(this, attachment);
          if (attachmentRespObj == false) {
            this.alert = true;
            return;
          }

          attachment = attachmentRespObj;  

          var urls = {};
          urls.url = URL.createObjectURL(attachment);
          urls.caption = '';
          urls.mention_users = [];

          if (this.text_msg) {
            urls.caption = this.text_msg;
          }

          urls.file = attachment;
          this.attachment_file_object = attachment;
          urls.type = fileType;
          if (urls.type == 'image') {
            this.getImageObject(urls.url);
          }

          this.get_attachment.push(urls);
          this.attachment_preview_object = this.get_attachment[(this.get_attachment.length - 1)];
          this.text_msg = '';
        });
      }
    },
    /**
     * at_add_user
     */
    at_add_user(user) {
      this.attachment_preview_object.mention_users.push(user);
    },
    /**
    * at_delete_user
    */
    at_delete_user(user) {
      this.attachment_preview_object.mention_users = this.attachment_preview_object.mention_users.filter((u) => u.user_id != user.participant_id);
    },
  },/*method closure */
  watch: {
    /**
     * src
     */
    attachment_src: function (attachments) {
      this.text_msg = this.message;
      this.addFiles(attachments);
    }
  }
}
